// hooks/useGetUsers.js
import { useQuery } from "@tanstack/react-query";
import { getAllUsers } from "../../api/apiUsers";
import i18next from "i18next";

export function useGetUsers(page = 1, perPage = 100, filters = {}) {

  const {
    isLoading,
    data,
    error,
  } = useQuery({
    queryKey: ["users", page, perPage, filters, i18next.language],
    queryFn: () => getAllUsers(page, perPage, filters),
    retry: false,
  });
  const Users = data?.data?.items || [];
  const meta = data?.data?.meta || { current_page: 1, per_page: perPage, total: 0 };
  return { isLoading, error, Users, meta };
}
